// @flow

import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import BackgroundImage from 'containers/fragments/BackgroundImageContainer';
import { dynamicClassName } from 'utils/dynamicClassName';
import { handleTagEvent } from 'utils/tagManagerUtils';

export type StateProps = {
  clubName: string,
  placeholder: string,
};

type Props = {
  url: string,
  backgroundUrl?: Object,
  title: string,
  linkLabel: string,
  desc?: string,
  isCompact?: boolean,
  isWide?: boolean,
  classAdd?: string,
} & StateProps;

class CardThumbnail extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    url: '#',
    isCompact: false,
    title: 'Bulletins officiels',
    linkLabel: 'En savoir plus',
    isWide: false,
    classAdd: ''
  };

  render() {
    const {
      url,
      isCompact,
      isWide,
      title,
      desc,
      linkLabel,
      backgroundUrl,
      clubName,
      classAdd,
      placeholder,
    } = this.props;
    const classNamesCard = dynamicClassName('box card card--content');
    isCompact && classNamesCard.add('card--compact');
    isWide && classNamesCard.add('card--wide');
    classAdd && classNamesCard.add(classAdd);

    return (
      <Link
        to={url}
        className={classNamesCard.build()}
        onClick={handleTagEvent(`card_${title}`, `clic_${linkLabel}`, clubName)}
      >
        <BackgroundImage
          className="card__thumbnail img-blue"
          illustration={(backgroundUrl && backgroundUrl.src) || placeholder}
          srcset={backgroundUrl && backgroundUrl.sizes}
          bypassClubPlaceholder />
        <div className="card__body">
          <h3 className="card__title">{title}</h3>
          {!isCompact && desc && <p className="card__desc">{desc}</p>}
        </div>
        <div className="card__footer">
          <span className="link-chevron">
            {linkLabel}
            <i className="icon icon-chevron-right" />
          </span>
        </div>
      </Link>
    );
  }
}

export default CardThumbnail;
